import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import React, { useState } from 'react';
import { Link, useLoaderData, useOutletContext } from 'react-router-dom';
import RowEditableTable from '../../../globalComponents/RowEditableTable';
import useReOrderingAPI from '../../apis/reorderingAPI';

const columns = [
  {
    title: 'Product',
    dataIndex: 'product_id',
    key: 'product_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Location',
    dataIndex: 'location_id',
    key: 'location_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'On Hand',
    dataIndex: 'on_hand_quantity',
    key: 'on_hand_quantity',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Forecast',
    dataIndex: 'forecast_quantity',
    key: 'forecast_quantity',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Preferred Route',
    dataIndex: 'preferred_route_id',
    key: 'preferred_route_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Vendor',
    dataIndex: 'vendor_id',
    key: 'vendor_id',
    editable: true,
    width: '15%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Min Quantity',
    dataIndex: 'min_quantity',
    key: 'min_quantity',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  
  {
    title: 'Max Quantity',
    dataIndex: 'max_quantity',
    key: 'max_quantity',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'To Order',
    dataIndex: 'to_order_quantity',
    key: 'to_order_quantity',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Trigger',
    dataIndex: 'trigger',
    key: 'trigger',
    editable: true,
    width: '10%',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: '',
    key: 'operation',
    // editable: true,
    fixed: 'right',
    // width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
  }
]


const preferredRoute = [
  {label: 'Buy', value: 'buy'},
  {label: 'Replenish On Order', value: 'mto'},
]

const triggers = [
  {label: 'Auto', value: 'auto'},
  {label: 'Manual', value: 'manual'},
]

const ProductReordering = () => {
  const {reordering, product, locations} = useLoaderData();
  const [editingKey, setEditingKey] = useState('');
  const [reOrderingRules, setReOrderingRules] = useState(reordering);
  const { success, error, CustomBreadcrumb } = useOutletContext();
  const { create } = useReOrderingAPI();
  

  const onClick = (record) => {
    let data = {...record};
    create(record, success)  
    console.log(data);
  }


  const addLine = () => {
    let reOrderingRules_ = [...reOrderingRules];
    let obj = {
      key: reOrderingRules.length + 1,
      location_id: '',
      product_id: '',
      on_hand_quantity: 0,
      forecast_quantity: 0,
      min_quantity: 0,
      max_quantity: 0,
      to_order_quantity: 0,
      preferred_route_id: '',
      vendor_id: '',
      trigger: 'auto'
    };
    reOrderingRules_.push(obj);
    setReOrderingRules(reOrderingRules_);
    setEditingKey(reOrderingRules.length + 1);
  }

  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'><CustomBreadcrumb /></h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'} onClick={addLine}>New</Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <RowEditableTable
        dataSource={reOrderingRules}
        setDataSource={setReOrderingRules}
        columns={columns}
        editingKey={editingKey}
        setEditingKey={setEditingKey}
        options={{products: [product], users: [], locations: locations,}}
        routes = {preferredRoute}
        triggers = {triggers}
        onClick={onClick}
      />
    
    </div>
  )
}

export default ProductReordering;